import { useEffect } from 'react';

/**
 * Names the one address a page should be indexed under.
 *
 * The homepage answers at both "/" and "/home" — the second exists so a
 * signed-in visitor can reach the marketing site at all, since "/" is the
 * dashboard once you are in. Two URLs serving identical copy is exactly what a
 * canonical link is for, and without it the pair competes with itself in
 * search results.
 *
 * The tag is tagged as ours and removed on unmount, so it can never linger over
 * a page it does not describe — the article pages get their canonical from the
 * server, and two would be worse than none.
 */
export function useCanonical(path: string): void {
  useEffect(() => {
    const tag = document.createElement('link');
    tag.rel = 'canonical';
    tag.dataset.app = 'true';
    tag.href = `${window.location.origin}${path}`;
    document.head.appendChild(tag);
    return () => { tag.remove(); };
  }, [path]);
}
